import React from 'react';
import {NCZIEhrExtract} from "../../../Interfaces/ncziTypes";
import EHRCompositionItemsAsList from "./EHRCompositionItemsAsList/EHRCompositionItemsAsList";

interface Props {
    ehrExtract: NCZIEhrExtract | undefined
    patientIdentifier: string
    onCloseDetail?: (needReload: boolean) => void
}

const EHRExtractUnpackCompositionItems: React.FC<Props> = (props) => {
    const {ehrExtract, patientIdentifier, onCloseDetail} = props;

    if(!ehrExtract) {
        return <></>;
    }

    return (
        <EHRCompositionItemsAsList items={ehrExtract.items[0]?.items || []} patientIdentifier={patientIdentifier} onCloseDetail={onCloseDetail} />
    );
};

export default EHRExtractUnpackCompositionItems;
